import { checkText, checkNumber } from './Rules'

export default {
    name: [
        // { required: true, message: 'Please input name', trigger: 'blur' },
        // { min: 1, max: 250, message: 'Length should be 1 to 250', trigger: 'blur' },
        // { validator: checkText, trigger: 'blur' },
    ],
    potentialAmount: [
        // { required: true, message: 'age is required'},
        // { type: 'number', message: 'age must be a number', trigger: 'blur'},
        // { validator: checkNumber, trigger: 'blur' },
    ],
    stickyNote: [
        // { validator: checkText, trigger: 'blur' }
    ],
}
